module.exports = __webpack_public_path__ + "img/icon-reset.0ab9dd03.svg";